var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00977C8.144 2.00977 5.00781 5.14791 5.00781 9.00391C5.00781 13.4869 10.9745 20.7692 11.2285 21.0762L12 22.0117L12.7715 21.0762C13.0255 20.7682 18.9922 13.4869 18.9922 9.00391C18.9922 5.14691 15.856 2.00977 12 2.00977ZM12 4.00977C14.753 4.00977 16.9922 6.25091 16.9922 9.00391C16.9922 11.7089 13.878 16.3612 12 18.8262C10.122 16.3632 7.00781 11.7129 7.00781 9.00391C7.00781 6.25091 9.247 4.00977 12 4.00977ZM12 6.5C10.619 6.5 9.5 7.619 9.5 9C9.5 10.381 10.619 11.5 12 11.5C13.381 11.5 14.5 10.381 14.5 9C14.5 7.619 13.381 6.5 12 6.5Z",
    fill: "#454A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.0817eb3057587bb9b6aa8fdf6ba484c7.svg";
export { ForwardRef as ReactComponent };